<template>
  <!-- 人员详情 -->
  <div class="personnelDetail">
    <el-form
      :disabled="status === 3"
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="userForm"
      :status-icon="false"
    >
      <el-form-item label="年龄>=" prop="">
            <el-input
              v-model="ruleForm.age"
              placeholder="年龄"
              show-word-limit

            />
            <!-- <el-input v-model="ruleForm.comment" placeholder="备注"> </el-input> -->
          </el-form-item>
    </el-form>
    <div v-if="status !== 3" class="bottomCenter">
      <h-button type="primary" @click="submitForm(ruleFormRef)">保存</h-button>
      <h-button @click="formVisible = false">取消</h-button>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch
} from "vue";
import { ElMessage } from "element-plus";
import { basesaveByAge } from "@/api/communityCare/communityCareApi.js";
import _ from "lodash";
export default defineComponent({
  name: "PersonnelDetail",
  components: { },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    formfather: {
      type: Object,
      default: () => ({})
    },
    status: {
      type: Number,
      default: 1 // 1 添加；2 编辑；3 只读
    }
  },
  emits: ["update:modelValue", "userSubmit"],
  setup(props, context) {
    const ruleFormRef = ref(null);
    const cascaderRef = ref(null);
    const state = reactive({
      formVisible: false,
      ruleForm: {
        age: "", //
        libraryId: ''

      },
      ruleFormBack: {},
      rules: {
        age: [
          {
            required: true,
            message: "请输入年龄",
            trigger: "blur"
          }
        ]
      }
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    const refData = toRefs(state);
    // 初始化表单
    const initForm = async () => {
      if (props.status === 1) {
        state.ruleForm.libraryId = props.formfather.libraryId;
      }
      ruleFormRef.value && ruleFormRef.value.resetFields();
    };
    // 监听
    watch(
      () => state.formVisible,
      v => {
        initForm();
      }
    );
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    const methods = {
      async submitForm(formEl) {
        if (!formEl) return;
        formEl.validate(async valid => {
          if (valid) {
            let res;
            if (props.status === 1) {
              res = await basesaveByAge(state.ruleForm);
            }
            if (res.code === 0) {
              ElMessage.success(props.status === 1 ? "添加成功" : "修改成功");
              context.emit("submit");
              state.formVisible = false;
              context.emit("update:modelValue", state.formVisible);
            }
          } else {
            console.log("error submit!");
            return false;
          }
        });
      }
    };

    return {
      ...refData,
      ...methods,
      ruleFormRef,
      cascaderRef
    };
  }
});
</script>
<style lang="scss" scoped>
.personnelDetail {
  .userForm {
    width: 100%;
    max-height: 500px;
    overflow: auto;
    padding: 20px;
    img {
      width: 100%;
      height: 100%;
    }
    :deep(.el-upload--picture-card) {
      width: 100px;
      height: 100px;
      font-size: 16px !important;
      .el-icon {
        margin-top: 36px !important;
      }
    }
    :deep(input) {
      // background-color: transparent !important;
      // height: 29px !important;
      box-sizing: border-box !important;
    }
    :deep(.el-select) {
      width: 100%;
    }
    :deep(.el-input) {
      width: 100%;
    }
    // :deep(.el-input__inner) {
    //   background: #fff !important;
    //   height: 29px !important;
    // }
    :deep(.el-cascader) {
      width: 100%;
    }
  }
  .formTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      width: 3.5px;
      height: 16px;
      background-color: #5584ff;
      margin-right: 10px;
    }
  }
  .margLeftLabel {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .bottomCenter {
    display: flex;
    justify-content: center;
    border-top: 1px solid;
    border-color: #eee;
    padding-top: 16px;
  }
  :deep(.el-input-group__prepend) {
    width: 150px;
    height: 100%;
    padding-right: 0px !important;
    box-sizing: border-box;
    .HSelectcode {
      width: 115% !important;
    }
  }
  .h-input {
    height: 29px !important;
    :deep(.select-trigger) {
      height: 100%;
      .el-input {
        height: 100%;
        .el-input__inner {
          height: 100%;
        }
      }
    }
  }
  .cardTypeItemStyle {
    /deep/.el-form-item__content {
      flex-wrap: nowrap;
    }

    .cardTypeStyle {
      width: 65%;
    }
  }
}
</style>
